import styled from "styled-components";
import { Image } from "../../../raw-components/image/image";

export const TopBannerImageDefaultBox = styled(Image)`
  position: absolute;
  width: 100%;
  height: auto;
  bottom: 0;
`;